import { render, staticRenderFns } from "./printInfo.vue?vue&type=template&id=63190ce8&scoped=true&"
import script from "./printInfo.vue?vue&type=script&lang=js&"
export * from "./printInfo.vue?vue&type=script&lang=js&"
import style0 from "./printInfo.vue?vue&type=style&index=0&id=63190ce8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63190ce8",
  null
  
)

export default component.exports